/**
 * Заменяет в шаблонной строке все вхождения плейсхолдеров на соответствующие значения из объекта
 * @param string
 * @param placeholders
 */
export const replacePlaceholders = (string: string, placeholders: Record<string, string>) => {
  const replacedText = string.replace(/\$\{([\s]*[^;\s{]+[\s]*)\}/g, (match) => {
    if (placeholders[match]) {
      return placeholders[match]
    }
    return ''
  })
  return replacedText.trim().length > 0 ? replacedText.trim() : ''
}
